import React, { useEffect } from "react";

const SkeepersWidget = ({ id, floating = false }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://widgets.rr.skeepers.io/generated/27f8bd37-d01e-8c54-4516-16c1c5b6f4cc/${id}.js`;
    script.defer = true;
    script.charset = "utf-8";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return floating ? <></> : <div id={id}></div>;
};

export default SkeepersWidget;
